module.exports = __webpack_public_path__ + "static/greenleebender2lg-08d464540342cb131d208a6c02bf1bb3.jpg";